import RestaurantListPage from './views/RestaurantListPage.vue';
import RestaurantDetailPage from './views/RestaurantDetailPage.vue';
import RestaurantMenuPage from './views/RestaurantMenuPage.vue';

export default [
  {
    path: '/restaurants',
    name: 'restaurants',
    component: RestaurantListPage,
    meta: {
      title: 'Restaurants',
      headerVisible: true,
      headerColor: 'ffffff'
    }
  },
  {
    path: '/restaurants/:id',
    name: 'restaurant-detail',
    component: RestaurantDetailPage,
    meta: {
      title: 'Restaurant',
      headerVisible: true,
      headerColor: 'ffffff'
    }
  },
  {
    path: '/restaurants/:id/menu',
    name: 'restaurant-menu',
    component: RestaurantMenuPage,
    meta: {
      title: 'Menu',
      headerVisible: true,
      headerColor: 'ffffff'
    }
  }
];
